import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14bd55d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fs-5 mb-0" }
const _hoisted_2 = {
  key: 0,
  class: "fs-6 fst-italic"
}
const _hoisted_3 = { class: "buttons d-flex justify-content-end align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "restart_alt", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-icon btn-primary ms-2",
  type: "submit"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "search")
], -1))
const _hoisted_7 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_8 = { class: "col-10" }
const _hoisted_9 = { class: "col position-relative d-flex justify-content-end" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "edit", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_13 = {
  class: "row",
  style: {"width":"800px"}
}
const _hoisted_14 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_15 = { class: "d-flex justify-content-center align-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_base_card_header = _resolveComponent("base-card-header")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputRadioBoolean = _resolveComponent("InputRadioBoolean")!
  const _component_InputTextEditor = _resolveComponent("InputTextEditor")!
  const _component_FloatingPanel = _resolveComponent("FloatingPanel")!
  const _component_SelectBrands = _resolveComponent("SelectBrands")!
  const _component_SelectCategories = _resolveComponent("SelectCategories")!
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputDate = _resolveComponent("InputDate")!
  const _component_base_card_body = _resolveComponent("base-card-body")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_dp_form = _resolveComponent("dp-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertError2, {
      error: _ctx.criteriaUI.getError()
    }, null, 8, ["error"]),
    _createVNode(_component_BaseSpinner, {
      spin: _ctx.criteriaUI.isNotReady()
    }, null, 8, ["spin"]),
    (_ctx.criteriaUI.isReady())
      ? (_openBlock(), _createBlock(_component_dp_form, {
          key: 0,
          as: "form",
          novalidate: "",
          onSubmit: _ctx.submitData
        }, {
          default: _withCtx(({ errors }) => [
            _createVNode(_component_base_card, {
              class: _normalizeClass(["criteria", {'is-changed': _ctx.productsCriteriaIsChanged}])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_card_header, null, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", _hoisted_1, [
                      _createTextVNode(_toDisplayString(_ctx.$t('filters')) + " ", 1),
                      (_ctx.productsCriteriaIsChanged)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(" + _toDisplayString(_ctx.$t('updated')) + ")", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-icon btn-danger",
                        type: "reset",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearCriteria && _ctx.clearCriteria(...args)), ["prevent"]))
                      }, _hoisted_5),
                      _hoisted_6
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_base_card_body, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputNumber, {
                      modelValue: _ctx.productsCriteria.filter_cnk_code,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productsCriteria.filter_cnk_code) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      label: _ctx.$t('cnkCode'),
                      name: "filter_cnk_code",
                      class: "mt-1",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.productsCriteria.search_keyword,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event: any) => ((_ctx.productsCriteria.search_keyword) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      label: _ctx.$t('keyword'),
                      name: "search_keyword",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputRadioBoolean, {
                      modelValue: _ctx.productsCriteria.filter_is_active,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => ((_ctx.productsCriteria.filter_is_active) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      label: _ctx.$t('active'),
                      name: "filter_is_active",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputRadioBoolean, {
                      modelValue: _ctx.productsCriteria.filter_is_apb_out_of_business,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.productsCriteria.filter_is_apb_out_of_business) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      label: _ctx.$t('commerciallyAvailable'),
                      name: "filter_is_apb_out_of_business",
                      "can-clear": "",
                      "is-inverted": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputRadioBoolean, {
                      modelValue: _ctx.customCriteria.photographyStatus,
                      "onUpdate:modelValue": [
                        _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customCriteria.photographyStatus) = $event)),
                        _ctx.onPhotographyStatusChanged
                      ],
                      label: _ctx.$t('toBePhotographed'),
                      name: "filter_photography_status_code",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputRadioBoolean, {
                      modelValue: _ctx.productsCriteria.filter_is_image_available,
                      "onUpdate:modelValue": [
                        _cache[6] || (_cache[6] = ($event: any) => ((_ctx.productsCriteria.filter_is_image_available) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      label: _ctx.$t('imageAvailable'),
                      name: "is_image_available",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputRadioBoolean, {
                      modelValue: _ctx.productsCriteria.filter_is_auto_categorized,
                      "onUpdate:modelValue": [
                        _cache[7] || (_cache[7] = ($event: any) => ((_ctx.productsCriteria.filter_is_auto_categorized) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      label: _ctx.$t('automaticallyCategorized'),
                      name: "filter_is_auto_categorized",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_InputRadioBoolean, {
                          modelValue: _ctx.productsCriteria.filter_is_in_user_cnk_filter,
                          "onUpdate:modelValue": [
                            _cache[8] || (_cache[8] = ($event: any) => ((_ctx.productsCriteria.filter_is_in_user_cnk_filter) = $event)),
                            _ctx.onCriteriaChanged
                          ],
                          label: _ctx.$t('inMyCnkList'),
                          name: "filter_is_in_user_cnk_filter",
                          "can-clear": "",
                          errors: errors
                        }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("button", {
                          class: "btn btn-icon btn-sm btn-primary mb-3",
                          onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editUserCnkFilter && _ctx.editUserCnkFilter(...args)), ["prevent"]))
                        }, _hoisted_11),
                        (_openBlock(), _createBlock(_component_FloatingPanel, {
                          visible: _ctx.isUserCnkFilterPanelVisible,
                          "max-height": 500,
                          onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isUserCnkFilterPanelVisible = false)),
                          key: 'panelKey'
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn-close",
                                    "aria-label": "Close",
                                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeUserCnkFilterPanel && _ctx.closeUserCnkFilterPanel(...args)))
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_InputTextEditor, {
                                  modelValue: _ctx.userCnkFilter,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.userCnkFilter) = $event)),
                                  mode: "bare",
                                  height: "300",
                                  width: "500",
                                  class: "col-12",
                                  label: _ctx.$t('myCnkList'),
                                  name: "userCnkFilter",
                                  errors: errors
                                }, null, 8, ["modelValue", "label", "errors"])
                              ]),
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-primary",
                                    "aria-label": "Save",
                                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.saveUserCnkFilterPanel && _ctx.saveUserCnkFilterPanel(...args)))
                                  }, _toDisplayString(_ctx.$t('save')), 1)
                                ])
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["visible"]))
                      ])
                    ]),
                    _createVNode(_component_SelectBrands, {
                      "selected-brand-codes": _ctx.productsCriteria.filter_brand_code ? [_ctx.productsCriteria.filter_brand_code] : [],
                      "catalog-customer-code": _ctx.catalogCustomerCode,
                      class: _normalizeClass([{'brand-selected': _ctx.productsCriteria.filter_brand_code}, "mb-3"]),
                      "btn-class": "btn btn-icon btn-outline-primary",
                      "is-pim-products": "",
                      onAddBrand: _ctx.setBrandCode,
                      onRemoveBrand: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setBrandCode(undefined)))
                    }, null, 8, ["selected-brand-codes", "catalog-customer-code", "class", "onAddBrand"]),
                    _createVNode(_component_SelectCategories, {
                      "selected-product-categories": _ctx.productsCriteria.filter_category_code_dp_managed ? [_ctx.productsCriteria.filter_category_code_dp_managed] : [],
                      "catalog-customer-code": _ctx.catalogCustomerCode,
                      class: _normalizeClass([{'category-selected': _ctx.productsCriteria.filter_category_code_dp_managed}, "mb-2"]),
                      "btn-class": "btn btn-icon btn-sm btn-outline-primary w-100",
                      "btn-icon": "category",
                      onAddCategory: _ctx.setCategoryCodeDpManaged,
                      onRemoveCategory: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setCategoryCodeDpManaged(undefined)))
                    }, null, 8, ["selected-product-categories", "catalog-customer-code", "class", "onAddCategory"]),
                    _createVNode(_component_InputCheckboxBoolean, {
                      modelValue: _ctx.productsCriteria.expect_products_in_subcategory,
                      "onUpdate:modelValue": [
                        _cache[16] || (_cache[16] = ($event: any) => ((_ctx.productsCriteria.expect_products_in_subcategory) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      label: _ctx.$t('includingSubcategories'),
                      name: "expect_products_in_subcategory",
                      class: "mb-4",
                      errors: errors
                    }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputSelect, {
                      modelValue: _ctx.productsCriteria.filter_dp_managed_category_cardinality,
                      "onUpdate:modelValue": [
                        _cache[17] || (_cache[17] = ($event: any) => ((_ctx.productsCriteria.filter_dp_managed_category_cardinality) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      options: _ctx.enumCategoryCardinality,
                      label: _ctx.$t('assignedDpCategories'),
                      name: "filter_dp_managed_category_cardinality",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "options", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputSelect, {
                      modelValue: _ctx.customCriteria.categoryCodeInternal,
                      "onUpdate:modelValue": [
                        _cache[18] || (_cache[18] = ($event: any) => ((_ctx.customCriteria.categoryCodeInternal) = $event)),
                        _ctx.onInternalProductCategoryChanged
                      ],
                      options: _ctx.optionsInternalProductCategory,
                      label: _ctx.$t('internalCategory'),
                      name: "filter_category_code_internal",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "options", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputSelect, {
                      modelValue: _ctx.productsCriteria.filter_category_code_apb,
                      "onUpdate:modelValue": [
                        _cache[19] || (_cache[19] = ($event: any) => ((_ctx.productsCriteria.filter_category_code_apb) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      options: _ctx.enumApbProductCategory,
                      label: _ctx.$t('apbCategoryCode'),
                      name: "filter_category_code_apb",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "options", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputSelect, {
                      modelValue: _ctx.productsCriteria.filter_category_code_apb_legal,
                      "onUpdate:modelValue": [
                        _cache[20] || (_cache[20] = ($event: any) => ((_ctx.productsCriteria.filter_category_code_apb_legal) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      options: _ctx.enumApbLegalCategory,
                      label: _ctx.$t('apbLegalCategoryCode'),
                      name: "filter_category_code_apb_legal",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "options", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputSelect, {
                      modelValue: _ctx.productsCriteria.filter_belmedis_availability_code,
                      "onUpdate:modelValue": [
                        _cache[21] || (_cache[21] = ($event: any) => ((_ctx.productsCriteria.filter_belmedis_availability_code) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      options: _ctx.enumBelmedisAvailability,
                      label: _ctx.$t('belmedisAvailability'),
                      name: "filter_belmedis_availability_code",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "options", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputSelect, {
                      modelValue: _ctx.productsCriteria.filter_febelco_availability_code,
                      "onUpdate:modelValue": [
                        _cache[22] || (_cache[22] = ($event: any) => ((_ctx.productsCriteria.filter_febelco_availability_code) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      options: _ctx.enumFebelcoAvailability,
                      label: _ctx.$t('febelcoAvailability'),
                      name: "filter_febelco_availability_code",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "options", "label", "errors", "onUpdate:modelValue"]),
                    _createVNode(_component_InputSelect, {
                      modelValue: _ctx.productsCriteria.filter_iprins_usage_type,
                      "onUpdate:modelValue": [
                        _cache[23] || (_cache[23] = ($event: any) => ((_ctx.productsCriteria.filter_iprins_usage_type) = $event)),
                        _ctx.onCriteriaChanged
                      ],
                      options: _ctx.enumIPrinsUsageType,
                      label: _ctx.$t('usage'),
                      name: "filter_iprins_usage_type",
                      "can-clear": "",
                      errors: errors
                    }, null, 8, ["modelValue", "options", "label", "errors", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_InputDate, {
                        modelValue: _ctx.productsCriteria.filter_product_creation_date_from,
                        "onUpdate:modelValue": [
                          _cache[24] || (_cache[24] = ($event: any) => ((_ctx.productsCriteria.filter_product_creation_date_from) = $event)),
                          _ctx.onCriteriaChanged
                        ],
                        label: _ctx.$t('from'),
                        name: "from",
                        placeholder: "DD-MM-JJJJ",
                        rules: "req_if_end:@from,@to",
                        "can-clear": "",
                        errors: errors
                      }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"]),
                      _createVNode(_component_InputDate, {
                        class: "ms-2",
                        modelValue: _ctx.productsCriteria.filter_product_creation_date_till,
                        "onUpdate:modelValue": [
                          _cache[25] || (_cache[25] = ($event: any) => ((_ctx.productsCriteria.filter_product_creation_date_till) = $event)),
                          _ctx.onCriteriaChanged
                        ],
                        label: _ctx.$t('to'),
                        name: "to",
                        placeholder: "DD-MM-JJJJ",
                        rules: "req_if_end:@from,@to",
                        "can-clear": "",
                        errors: errors
                      }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["class"])
          ]),
          _: 1
        }, 8, ["onSubmit"]))
      : _createCommentVNode("", true)
  ], 64))
}